module.exports = {"id":"232883","name":"Gaku Shibasaki","rating":"75","photo":"./data/images/photos/3/232883.png","club":{"name":"Getafe CF","logo":"./data/images/clubs/GetafeCF.png"},"positions":["MDC","MOC","MD","BU"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/GakuShibasaki0.json
// module id = 1526
// module chunks = 0